import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidemenu from '../base/sidemenu';
import { deleteDevice } from "../../services/deviceService";

export default function DeviceDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const device = location.state?.device || {};
  const token = localStorage.getItem("token");
  console.log("장비 상세", device)
  const handleGoBack = () => {
    navigate(-1);
  };
  const handleDelete = async () => {
    console.log("삭제");
    if (window.confirm(`${device.plug_name}님의 장비를 정말로 삭제하시겠습니까?`)) {
      try {
        const data = await deleteDevice(device.id, token);
        if (!data.success) {
          alert(data.message);
          console.error("기기 삭제 :", data);
          return;
        }
        alert(data.message);
        navigate("/device")
        console.log("기기 삭제:", data);
      } catch (error) {
        alert(error);
        console.error("기기 삭제:", error);
      }
    } else {
      alert("취소되었습니다.");
    };

  };
  return (
    <div className='flex'>
      <Sidemenu />
      <div className="device">
        <h1>장비 관리</h1>
        <div className="device_box">
          <div className="device_detail">
            <h2 className="subpage_title"><span className="before"><span className="nametit">{device.plug_name}</span> 님의 장비 상세정보</span></h2>
            <div className="detail_box">
              <ul>
                <li><p className="tit">장비이름</p><p className="txt">{device.plug_id}</p></li>
                <li><p className="tit">사용자이름</p><p className="txt">{device.name || "-"}</p></li>
                <li><p className="tit">설치 유무</p><p className="txt" style={{fontWeight: "400", color: device.is_matched === 1 ? "#0087ff" : "#f00" }}>{device.is_matched === 1 ? "설치됨" : "설치안됨"}</p></li>
                <li><p className="tit">설치위치</p><p className="txt">{device.address || "-"}</p></li>
                <li><p className="tit">플러그 상태</p>
                  <p className="txt"><span style={{ display: "inline-block", textAlign: "center", width: "100px", padding: "3px 0", borderRadius: "3px", color: "white", backgroundColor: device.plug_status === 1 ? "#22c55e" : "#ef4444" }}>{device.plug_status === 1 ? "정상" : "비정상"}</span></p>
                </li>
                <li><p className="tit">스위치 상태</p>
                  <p className="txt"><span style={{ display: "inline-block", textAlign: "center", width: "100px", padding: "3px 0", borderRadius: "3px", color: "white", backgroundColor: device.swich_status === 1 ? "#22c55e" : "#ef4444" }}>{device.swich_status === 1 ? "정상" : "비정상"}</span></p>
                </li>
                <li><p className="tit">마지막 응답</p><p className="txt">{device.create_date}</p></li>
              </ul>
            </div>
          </div>
          <div className="btn-group">
            {/* <button className="btncolor04" onClick={handleDelete}>삭제</button> */}
{/* 
            <button className="btncolor02" onClick={handleDelete}>삭제</button> */}
            {!device.address && (
              <button
                className="btncolor04"
                onClick={() => navigate("/device/new", { state: { device } })}
              >
                사용자 등록
              </button>
            )}

            <button className="btncolor01" onClick={handleGoBack}>확인</button>

          </div>
        </div>
      </div>
    </div>
  );
}
